import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-323.56 -348.44 2311.11 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M1020.5 387.5Q1152 519 1152.0 704.0Q1152 889 1020.5 1020.5Q889 1152 704.0 1152.0Q519 1152 387.5 1020.5Q256 889 256.0 704.0Q256 519 387.5 387.5Q519 256 704.0 256.0Q889 256 1020.5 387.5ZM1664 -128Q1664 -180 1626.0 -218.0Q1588 -256 1536 -256Q1482 -256 1446 -218L1103 124Q924 0 704 0Q561 0 430.5 55.5Q300 111 205.5 205.5Q111 300 55.5 430.5Q0 561 0.0 704.0Q0 847 55.5 977.5Q111 1108 205.5 1202.5Q300 1297 430.5 1352.5Q561 1408 704.0 1408.0Q847 1408 977.5 1352.5Q1108 1297 1202.5 1202.5Q1297 1108 1352.5 977.5Q1408 847 1408 704Q1408 484 1284 305L1627 -38Q1664 -75 1664 -128Z"
	})
});
export default SvgSearch;
